module.exports = __webpack_public_path__ + "img/caret-down.74fae52a.svg";